import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    formData: {
      user: '',
      l1: '',
      l2: '',
      l3: '',
      vendor: '',
    },
    searchText: '',
  },
}

export const skuFiltersSlice = createSlice({
  name: 'sku-filters',
  initialState,
  reducers: {
    setSkuFilterValues: (state, action) => {
      state.filters = action.payload
    },
    clearSkuFilters: () => initialState,
  },
})

export const { setSkuFilterValues, clearSkuFilters } = skuFiltersSlice.actions

export default skuFiltersSlice.reducer
